import { ActionTree } from 'vuex'

import { QlogState, RootState } from '@/types/store'
import { IQlog, QlogParams } from '@/types/qlog'

import { createLog, getLogs } from '@/api/qlogs'

export const actions: ActionTree<QlogState, RootState> = {
  async createLog(_, log: IQlog): Promise<void> {
    await createLog(log)
  },
  async getLogs({ commit }, params: QlogParams): Promise<void> {
    commit('setIsLogsLoading', true)
    const logs = await getLogs(params)
    commit('setIsLogsLoading', false)
    commit('logsLoaded', logs)
  },
}
